export default function ({ type, field = 'form', loadOnMounted = true }) {
  return {
    data() {
      return {
        draft_key: 'unset',
      }
    },
    mounted() {
      if (loadOnMounted && this.draft_key)
        this.draft_load()
    },
    methods: {
      draft_load() {
        const data = this.$store.getters.draft(type).load(this.draft_key)
        if (data) {
          this.$set(this, field, data)
          return true
        }
        return false
      },
      draft_save() {
        this.$store.commit('DRAFT_SAVE', { type, key: this.draft_key, data: this.draft })
      },
      draft_remove() {
        this.$store.commit('DRAFT_DELETE', { type, key: this.draft_key })
      },
      draft_key_generate() {
        this.draft_key = `${this.no}-${this.$moment().format('YYYYMMDD-HHmmss')}`
      },
    },
  }
}



// WEBPACK FOOTER //
// ./client/src/mixins/draft.js